// extracted by mini-css-extract-plugin
module.exports = {"root":"FullPopup_root__G_AXs","logo":"FullPopup_logo__kTsj6","header":"FullPopup_header__m6g3U","close":"FullPopup_close__zi1aC","bgGreen":"FullPopup_bgGreen__aVa0A"};